/** @format */

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import {
	selectInventoryExceededStatus,
	selectMaxOrMinQuantityAlert
} from '@pdp/add-to-cart/data-access';
import { Store } from '@ngrx/store';
import { HmfAlertBannerComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-feature-add-to-cart-alerts',
	imports: [HmfAlertBannerComponent],
	templateUrl: './add-to-cart-alerts.component.html',
	styleUrl: './add-to-cart-alerts.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddToCartAlertsComponent {
	private readonly store = inject(Store);

	// NgRx selectors as signals
	readonly inventoryExceededStatus = this.store.selectSignal(selectInventoryExceededStatus);
	readonly maxOrMinQuantityAlert = this.store.selectSignal(selectMaxOrMinQuantityAlert);

	// Computed signal for inventory exceeded message
	readonly inventoryExceededText = computed(() => {
		const status = this.inventoryExceededStatus();
		if (status?.inventoryExceeded) {
			return `Only ${status.maxInventory} unit(s) available to be purchased`;
		}
		return undefined;
	});
}
